<script>
  import { onMount, tick, createEventDispatcher } from 'svelte';

  export let outputData = {};
  export let dados_inicias = {};

  const dispatch = createEventDispatcher();
   let usuarioInteragiu = false;
  export let currentMonth = new Date().getMonth();
  export let currentYear = new Date().getFullYear();
  let dates = [];
  let dateTextMap = {};
  const daysOfWeek = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'];

  let prevDadosIniciaisStr = '{}';
  let prevOutputDataStr = '{}';
  export let carregou_planilha=false;
  function syncInternalMapFromProps(currentDadosIniciais, currentOutputData) {
    const newMap = {};
    for (const key in currentDadosIniciais) {
      const item = currentDadosIniciais[key];
      if (item && Array.isArray(item) && item[0]?.texto_livre) {
        newMap[key] = item[0].texto_livre;
        
        
      }
    }
    for (const key in currentOutputData) {
      const item = currentOutputData[key];
      if (item && Array.isArray(item) && item[0]?.texto_livre) {
        newMap[key] = item[0].texto_livre;
      } else if (newMap.hasOwnProperty(key)) {
        delete newMap[key];
      }
    }
    if (JSON.stringify(newMap) !== JSON.stringify(dateTextMap)) {
      dateTextMap = newMap;
      return true;
    }
    dispatch('dataChange', getFormattedOutput());
   
    return false;
  }

export async function Inicializa (e=null){
  if(e){
    dados_inicias=e;
  }
   syncInternalMapFromProps(dados_inicias, outputData);
    dates = getDaysInMonth(currentYear, currentMonth);
    await tick();

    prevDadosIniciaisStr = JSON.stringify(dados_inicias || {});
    prevOutputDataStr = JSON.stringify(outputData || {});

    const initialEffectiveOutput = getFormattedOutput();
    if (JSON.stringify(initialEffectiveOutput) !== prevOutputDataStr) {
      dispatch('dataChange', initialEffectiveOutput);
    }
}
  onMount(async () => {
   await Inicializa();
// await tick();
   // await AtualizaOsConteudos();
   //  await tick();
  });

  $: {
    const currentDadosIniciaisJson = JSON.stringify(dados_inicias || {});
    const currentOutputDataJson = JSON.stringify(outputData || {});
    let needsSync = false;
    if (currentDadosIniciaisJson !== prevDadosIniciaisStr) {
      prevDadosIniciaisStr = currentDadosIniciaisJson;
      needsSync = true;
    }
    if (currentOutputDataJson !== prevOutputDataStr) {
      prevOutputDataStr = currentOutputDataJson;
      needsSync = true;
    }
    if (needsSync) {
      if (syncInternalMapFromProps(dados_inicias, outputData)) {
        tick();
      }
    }
  }

  function formatDateISO(date) {
    if (!(date instanceof Date) || isNaN(date)) return '';
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
  }

  function getDaysInMonth(year, month) {
    const arr = [];
    const dt = new Date(year, month, 1);
    const firstDay = dt.getDay();
    for (let i = 0; i < firstDay; i++) arr.push(null);
    while (dt.getMonth() === month) {
      arr.push(new Date(dt));
      dt.setDate(dt.getDate() + 1);
    }
    return arr;
  }

  async function changeMonth(direction) {
    if (direction === 'prev') {
      currentMonth--;
      if (currentMonth < 0) { currentMonth = 11; currentYear--; }
    } else {
      currentMonth++;
      if (currentMonth > 11) { currentMonth = 0; currentYear++; }
    }
    dates = getDaysInMonth(currentYear, currentMonth);
    await tick();
    dispatch('mudou_mes', {direction:direction, outputData:outputData});
  }
  export function CarregouPlanilha(){
    //  console.log("CarregouPlanilha",carregou_planilha, dates, dateTextMap, carregou_planilha);
if(carregou_planilha){

  changeMonth( 'prev');
  changeMonth( 'next'); 
}

  }
  function getDayBaseClasses(date) {
    if (!date) return 'day empty';
    const today = new Date();
    today.setHours(0,0,0,0);
    let cls = 'day';
    if (date.getTime() === today.getTime()) cls += ' today';
    return cls;
  }
function AtualizaOsConteudos(){
  dates.forEach((date) => {
 //  console.log("AtualizaOsConteudos", date, formatDateISO(date), dateTextMap[formatDateISO(date)]);
   
      inserirTextoENotificar( formatDateISO(date)) 
 
    
    
  });    
  tick();
}
  function getFormattedOutput() {
    const out = {};
    for (const key in dateTextMap) {
      const text = dateTextMap[key]?.trim();
      if (text) {
        out[key] = [{ texto_livre: text, salvar_em_lista: 0, titulo: '' }];
      }
    }
   // console.log('getFormattedOutput', out);
    // dispatch('dataChange', getFormattedOutput());
    return out;
  }

  function handleUserInteraction(formattedDate, newText) {
    const trimmed = newText.trim();
    let mapChanged = false;
    if (trimmed) {
      if (dateTextMap[formattedDate] !== trimmed) {
        dateTextMap = { ...dateTextMap, [formattedDate]: trimmed };
        mapChanged = true;
      }
    } else if (dateTextMap.hasOwnProperty(formattedDate)) {
      const { [formattedDate]: _, ...rest } = dateTextMap;
      dateTextMap = rest;
      mapChanged = true;
    }
    if (mapChanged) {
      dispatch('dataChange', getFormattedOutput());
    }
  }
function inserirTextoENotificar( date) {
  //if(usuarioInteragiu) return;
    const selector = `div${date}`;
  

  const el = document.getElementById(selector);
 // console.log("inserirTextoENotificar", selector, el, date);
  if (el) {

    const previousContent = el.innerHTML;
    clearDivContent(selector);
    el.textContent = previousContent;

    // Cria e despacha manualmente o evento de input
    const event = new Event('input', { bubbles: true });
    el.dispatchEvent(event);
    tick();
    // Agora chama sua função handleTextInput com o evento simulado e a data
    handleTextInput2({ target: el }, date);
      tick();
  }
}

  async function handleTextInput(event, date) {
    //usuarioInteragiu = true;
    if (!date) return;
    const formatted = formatDateISO(date);
    if (!formatted) return;
    handleUserInteraction(formatted, event.target.textContent || '');
  }
   async function handleTextInput2(event, date) {
    if (!date) return;
    const formatted = formatDateISO(date);
    if (!formatted) return;
    handleUserInteraction(formatted, event.target.textContent || '');
  }

  function handleBlur(event, date) {
    if (!date) return;
    const formatted = formatDateISO(date);
    if (!formatted) return;
    handleUserInteraction(formatted, event.target.textContent || '');
  }

  function clearAllText() {
    if (confirm('Tem certeza que deseja apagar todas as anotações deste calendário?')) {
      let hadText = Object.keys(dateTextMap).length > 0;
      dateTextMap = {};
      if (hadText) {
        dispatch('dataChange', getFormattedOutput());
      }
    }
  }

  function clearCellText(event, date) {
    event.stopPropagation();
    const key = formatDateISO(date);
    if (dateTextMap[key]) {
      const { [key]: _, ...rest } = dateTextMap;
      dateTextMap = rest;
     clearDivContent(key);
      dispatch('dataChange', getFormattedOutput());
    }
  }

  function getCellText(date) {
    const key = date ? formatDateISO(date) : null;
    if (!key) return '';
    ///console.log("data e conteudo",dateTextMap[key], key, dateTextMap);
    return dateTextMap[key] || '';
  }


  function clearDivContent(idParam) {
    const selector = `div#div${idParam}`;
 
    const el = document.querySelector(selector);
    if (!el) {
     // console.warn(`clearDivContent: elemento '${selector}' não encontrado.`);
      return null;
    }
    const previousContent = el.innerHTML;
    el.innerHTML = '';
    
    }

    function UsuarioInteragiu() {
     // usuarioInteragiu = true;
     
    }
</script>

<div class="interval-calendar-container-large">
  <div class="calendar-header">
    <button class="nav-arrow" on:click={() => changeMonth('prev')}>❮</button>
    <span class="month-year">{new Date(currentYear, currentMonth).toLocaleDateString('pt-BR', { month: 'long', year: 'numeric' })}</span>
    <button class="nav-arrow" on:click={() => changeMonth('next')}>❯</button>
  </div>
  <div class="days-of-week">
    {#each daysOfWeek as day}
      <div>{day}</div>
    {/each}
  </div>
  <div class="calendar-grid">
    {#each dates as date, i (date ? formatDateISO(date) : `empty-${i}`)}
      {@const key = date ? formatDateISO(date) : null}
     

      <div  class="{getDayBaseClasses(date)} {date && key && dateTextMap[key] ? 'green-background' : ''}">
        {#if date}
          <button class="clear-cell-button" on:click={(e) => clearCellText(e, date)} tabindex="-1">×</button>
          <span class="day-number">{date.getDate()}</span>
          <div id={"div"+formatDateISO(date)} class="editable-text" contenteditable spellcheck="false" tabindex="0"
               on:input={(e) => handleTextInput(e, date)}
               on:blur={(e) => handleBlur(e, date)}
               aria-label="Anotação para {date.toLocaleDateString('pt-BR')}">
            {getCellText(date)}
          </div>
    
     
     
    
        {/if}
      </div>
    {/each}

  </div>
  <div class="calendar-footer">
    <button class="clear-button" on:click={clearAllText}>Limpar Todas Anotações</button>
  </div>
</div>

 

<style>
  .interval-calendar-container-large { display: flex; flex-direction: column; width: 100%; max-width: 1200px; min-height: 70vh; margin: 10px auto; font-family: sans-serif; border: 1px solid #ccc; border-radius: 8px; padding: 20px; background-color: #fdfdfd; box-sizing: border-box; }
  .calendar-header { display: flex; justify-content: space-between; align-items: center; padding: 15px 10px; margin-bottom: 15px; border-bottom: 1px solid #eee; }
  .month-year { font-weight: bold; font-size: 1.4em; text-transform: capitalize; }
  .nav-arrow { background: none; border: none; font-size: 1.8em; cursor: pointer; padding: 0 15px; color: #007bff; }
  .nav-arrow:hover { color: #0056b3; }
  .days-of-week, .calendar-grid { display: grid; grid-template-columns: repeat(7, 1fr); gap: 5px; text-align: center; }
  .days-of-week { font-weight: bold; color: #555; padding-bottom: 10px; margin-bottom: 5px; font-size: 0.9em; }
  .days-of-week div { padding: 8px 5px; }
  .calendar-grid { gap: 4px; flex-grow: 1; }
  .day { min-height: 100px; border: 1px solid #e0e0e0; background-color: #fff; display: flex; flex-direction: column; align-items: flex-start; justify-content: flex-start; padding: 5px; position: relative; overflow: hidden; transition: background-color 0.2s ease-in-out, border-color 0.2s ease-in-out; }
  .day.empty { background-color: #f8f9fa; border-color: transparent; }
  .day.green-background { background-color: #e9f5e9; border-color: #c8e6c9; }
  .day.green-background .day-number { color: #2e7d32; }
  .day.green-background .editable-text { color: #1b5e20; }
  .day.green-background .editable-text:focus { background-color: #dceddc; border-color: #2e7d32 !important; box-shadow: 0 0 0 1px rgba(46, 125, 50, 0.3) !important; }
  .day.today { border: 2px solid #007bff; font-weight: bold; }
  .day.today .day-number { color: #007bff; }
  .day.today.green-background { border: 2px solid #007bff; }
  .day.today.green-background .day-number { color: #007bff; }
  .day-number { font-size: 0.85em; font-weight: bold; color: #333; margin-bottom: 4px; padding: 2px 4px; align-self: flex-start; z-index: 1; }
  .editable-text { width: 100%; flex-grow: 1; font-size: 0.9em; line-height: 1.3; padding: 4px; box-sizing: border-box; border: 1px solid transparent; border-radius: 3px; overflow-y: auto; cursor: text; min-height: 50px; white-space: pre-wrap; word-wrap: break-word; outline: none; color: #212529; transition: background-color 0.2s ease, border-color 0.2s ease; }
  .editable-text:focus { border: 1px solid #007bff; background-color: #f0f8ff; box-shadow: 0 0 0 1px rgba(0, 123, 255, 0.25); }
  .editable-text:empty::before { content: "Clique para editar..."; color: #aaa; font-style: italic; pointer-events: none; display: block; }
  .calendar-footer { margin-top: 20px; padding-top: 15px; border-top: 1px solid #eee; text-align: right; }
  .clear-button { padding: 10px 20px; font-size: 1em; background-color: #dc3545; color: white; border: none; border-radius: 4px; cursor: pointer; transition: background-color 0.2s ease; }
  .clear-button:hover { background-color: #c82333; }
  .clear-cell-button { position: absolute; top: 2px; right: 2px; background: rgba(200, 200, 200, 0.5); color: #555; border: none; border-radius: 50%; width: 18px; height: 18px; font-size: 14px; line-height: 16px; text-align: center; cursor: pointer; opacity: 0; transition: opacity 0.2s ease, background-color 0.2s ease; z-index: 2; padding: 0; }
  .day:hover .clear-cell-button { opacity: 1; }
  .clear-cell-button:hover { background-color: rgba(220, 53, 69, 0.7); color: white; }
  .day .clear-cell-button { display: none; }
  .day.green-background:hover .clear-cell-button { display: block; opacity: 1; }
  .day:not(.green-background):hover .clear-cell-button { display: none; }
</style>